import {Column, HeaderProps} from 'react-table'
import {ILedger} from './_model'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../utils/components/table-content/CustomHeader'
import {dateFormat} from '../../utils/helperFunction/_helper'
import {Link} from 'react-router-dom'

const ledgerColumn: ReadonlyArray<Column<ILedger>> = [
  {
    Header: (props: PropsWithChildren<HeaderProps<ILedger>>) => (
      <CustomHeader tableProps={props} title='date' className='min-w-100px' />
    ),
    id: 'date',
    accessor: 'date',
    Cell: ({...props}) => (
      <span>
        {props.data[props.row.index].date && dateFormat(props.data[props.row.index].date, true)}
      </span>
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILedger>>) => (
      <CustomHeader tableProps={props} title='Type' className='min-w-100px' />
    ),
    id: 'type',
    accessor: 'type',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILedger>>) => (
      <CustomHeader tableProps={props} title='reference' className='min-w-100px' />
    ),
    id: 'reference',
    accessor: 'reference',
    Cell: ({...props}) => {
      const ledger = props.data[props.row.index]

      if (ledger.type === 'INVOICE' && ledger.invoice_id)
        return <Link to={`/billing/invoice/${ledger.invoice_id}`}>{ledger.reference}</Link>
      if (ledger.type === 'RECEIPT' && ledger.voucher_id)
        return <Link to={`/billing/voucher/preview/${ledger.voucher_id}`}>{ledger.reference}</Link>

      return <>{ledger.reference}</>
    },
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILedger>>) => (
      <CustomHeader tableProps={props} title='debit' className='min-w-100px' />
    ),
    id: 'debit',
    accessor: 'debit',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILedger>>) => (
      <CustomHeader tableProps={props} title='credit' className='min-w-100px' />
    ),
    id: 'credit',
    accessor: 'credit',
  },

  {
    Header: (props: PropsWithChildren<HeaderProps<ILedger>>) => (
      <CustomHeader tableProps={props} title='balance' className='min-w-100px' />
    ),
    id: 'running_balance',
    accessor: 'running_balance',
  },
]

export default ledgerColumn
